import { Code, Text } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonDialog } from 'components/common/dialogs';
import { ErrorBoundary } from 'components/common/error-boundary';
import { useMachinesPortalStore } from 'components/sections/admin-portal/machines/store/use-machines-portal-store';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { AdminMachinesService } from 'services/admin/machines.service';

const COMPONENT_NAME = 'ResetConnectionsDialog';

interface IProps {
  machineID: string;
  onClose: () => void;
}

export const ResetConnectionsDialog = ({ machineID, onClose }: IProps) => {
  const fetchMachinesAndModels = useMachinesPortalStore(
    (s) => s.fetchMachinesAndModels
  );

  const handleResetConnections = async () => {
    try {
      await AdminMachinesService.getInstance().resetConnections(machineID);
      await fetchMachinesAndModels();
      onClose();
    } catch (error) {
      console.error(error);
      NotifyHelper.info({
        message_md: `Failed to reset connections for ${machineID}, please check console.`,
      });
    }
  };

  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      <CommonDialog
        identifier={COMPONENT_NAME}
        width={RADIX.DIALOG.WIDTH.MD}
        title="Reset Connections"
        content={
          <Text>
            <p>
              All users (active and waiting) on <Code>{machineID}</Code> will be
              disconnected if you proceed.
            </p>
            <p>Please ensure the machine is not in use.</p>
          </Text>
        }
        buttons={[
          {
            label: 'common.reset-connections',
            color: RADIX.COLOR.WARNING,
            onClick: handleResetConnections,
          },
        ]}
        onClose={onClose}
      />
    </ErrorBoundary>
  );
};
